import "../Styles/AdminListings.css";

export const billReportColumns =(handleDownlodLinkClick)=> [
    {
        name: 'Id',
        minWidth: "120px",
        selector: row => row.id,
        //sortable: true,
        wrap: true,
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center"
        },
        //sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName: ""),
    },
    {
        name: 'Report Date ',
        minWidth: "220px",
        selector: row => row.jobRunDate ? row.jobRunDate : "",
        //sortable: true,
        wrap: true,
        center:true,
        style: {
            justifyContent: "center",
            textAlign:"center"
        },
        //sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.jobRunDate? row.careFacilityName:""),
    },
    {
		name: 'File',
		//minWidth: "200px",
		align: "center",
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"200px",
        },
		cell : (row, props) =>  (
			<div>
				{(row.billingFileName) ? 
                <a href="#" onClick={()=>handleDownlodLinkClick(row, props)}>
                    {row.billingFileName}</a>
				: "No Data"
				}
			</div>)
	},
];
